import { render, staticRenderFns } from "./HotelDetailsPopup.vue?vue&type=template&id=c1cf407e&scoped=true"
import script from "./HotelDetailsPopup.vue?vue&type=script&lang=js"
export * from "./HotelDetailsPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1cf407e",
  null
  
)

export default component.exports